import React from 'react';
import './VTCamSwapModal.css';

export default function VTCamSwapModal({
  open,
  onClose,
  onAddView,
  onSwapView,
  pendingCamera,
}) {
  if (!open) return null;

  return (
    <div className="vt-modal-backdrop" onClick={onClose}>
      <div
        className="vt-modal-card"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <button className="vt-modal-close" onClick={onClose} aria-label="Close">
          ×
        </button>

        <div className="vt-modal-icon">
          <svg viewBox="0 0 24 24" width="40" height="40" fill="#f59e0b">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
          </svg>
        </div>

        <p className="vt-modal-text">
          For optimal data usage and quality, we recommend streaming only 1 camera angle at a time.
        </p>

        <div className="vt-modal-actions">
          <button
            type="button"
            className="vt-btn vt-btn-outlined"
            onClick={() => onAddView(pendingCamera)}
          >
            View Multi Cam Angle
          </button>

          <button
            type="button"
            className="vt-btn vt-btn-contained"
            onClick={() => onSwapView(pendingCamera)}
          >
            Keep Single Cam
            <span style={{ display: 'block', fontSize: '11px', fontWeight: 'normal', marginTop: '2px' }}>
              ({pendingCamera})
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
